module.exports = __webpack_public_path__ + "static/media/2.5b8abdf8.mp3";